import { useEffect, useMemo, useState } from 'react';

import {
  DEFAULT_CHARGE_AFTER_DAYS,
  INCOMEIQUEUE_RCM_ACTION_VALUES,
  MIN_CHARGE_AFTER_DAYS,
  getScenarioAction,
  getScenarioChargeAfter
} from 'lib/constants/healthcareProgram/incomeIQueueRcm';

import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';
import Typography from 'components/shared/Typography/Typography';

const MAX_CHARGE_AFTER_DAYS = 90;

const IncomeIQueueStepRow = ({ label, value, options, onChange, dataQa }) => {
  const actionValue = getScenarioAction(value);
  const chargeAfter = getScenarioChargeAfter(value);

  const selectedOption = useMemo(
    () => options.find((option) => option.value === actionValue) || null,
    [options, actionValue]
  );

  const isAutoCharge = actionValue === INCOMEIQUEUE_RCM_ACTION_VALUES.SEND_INVOICE_AND_AUTO_CHARGE;

  const [chargeAfterInput, setChargeAfterInput] = useState(
    chargeAfter == null ? '' : String(chargeAfter)
  );

  useEffect(() => {
    setChargeAfterInput(chargeAfter == null ? '' : String(chargeAfter));
  }, [chargeAfter]);

  const handleActionChange = (nextAction) => {
    if (!nextAction) {
      onChange(null);
      return;
    }

    if (nextAction === INCOMEIQUEUE_RCM_ACTION_VALUES.SEND_INVOICE_AND_AUTO_CHARGE) {
      onChange({ action: nextAction, charge_after: chargeAfter ?? DEFAULT_CHARGE_AFTER_DAYS });
      return;
    }
    onChange(nextAction);
  };

  const handleChargeAfterChange = (event) => {
    setChargeAfterInput(event.target.value);
  };

  const commitChargeAfter = () => {
    const parsed = Number(chargeAfterInput);
    const fallback = chargeAfter ?? DEFAULT_CHARGE_AFTER_DAYS;
    const next =
      chargeAfterInput.trim() === '' || !Number.isFinite(parsed)
        ? fallback
        : Math.min(MAX_CHARGE_AFTER_DAYS, Math.max(MIN_CHARGE_AFTER_DAYS, Math.round(parsed)));

    setChargeAfterInput(String(next));
    if (next !== chargeAfter) {
      onChange({
        action: INCOMEIQUEUE_RCM_ACTION_VALUES.SEND_INVOICE_AND_AUTO_CHARGE,
        charge_after: next
      });
    }
  };

  return (
    <div
      className="flex items-center gap-3 rounded-md border border-solid border-neutral-200 bg-neutral-50 px-3 py-[6px]"
      data-qa={dataQa}>
      <Typography size="small" color="neutral-900">
        {label}
      </Typography>
      <Select
        id={dataQa}
        value={selectedOption}
        options={options}
        isClearable={false}
        placeholder="Select an action"
        onChange={(option) => handleActionChange(option?.value)}
        styles={{ container: { width: 'fit-content' } }}
      />
      {isAutoCharge && (
        <div className="ml-auto flex items-center gap-2">
          <div className="w-24">
            <Input
              id={`${dataQa}-charge-after`}
              data-qa={`${dataQa}-charge-after`}
              type="number"
              value={chargeAfterInput}
              onChange={handleChargeAfterChange}
              onBlur={commitChargeAfter}
              min={MIN_CHARGE_AFTER_DAYS}
              max={MAX_CHARGE_AFTER_DAYS}
            />
          </div>
          <Typography size="small" color="neutral-700">
            days
          </Typography>
        </div>
      )}
    </div>
  );
};

export default IncomeIQueueStepRow;
